export enum GalleryManagerSection {
  Photos = 'photos',
  Videos = 'videos',
}
